import React, { useState } from 'react'
import { useStyles } from './FlyoutLandingPageSection.styles'
import { FormLockedType } from '../../../../types/FormLockedType'
import { landingPageImages } from '../../../../common/utils/productCreationUtil'
import {
  Carousel,
  ModalConfirmV2,
  ModalSizeVariants,
} from '@labrav/react-components'
import { FlyoutProductAddEditSectionName } from '../../../../types/addEditProduct'
import { FlyOutProductAdhere } from '../../../AddEditProductFormComponents/FlyOutProductAdhere/FlyOutProductAdhere'
import { FlyOutProductLandingPageConfiguration } from '../../../AddEditProductFormComponents/FlyOutProductLandingPageConfiguration/FlyOutProductLandingPageConfiguration'
import { FlyOutProductBranding } from '../../../AddEditProductFormComponents/FlyOutProductBranding/FlyOutProductBranding'
import { defaultNow } from '../../../../common/utils/dateTimeNow'
import { FlyOutProductFormFields } from '../../../AddEditProductFormComponents/FlyOutProductFormFields/FlyOutProductFormFields'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAws } from '@fortawesome/free-brands-svg-icons'
import { FlyOutProductRedirectionSettingsMicrosoft } from '../../../AddEditProductFormComponents/FlyOutProductRedirectionSettingsMicrosoft/FlyOutProductRedirectionSettingsMicrosoft'
export interface FlyoutLandingPageSectionProps {
  detailView?: boolean
  detailViewTooltip?: string
  productView?: boolean
}

export const FlyoutLandingPageSection = ({
  detailView,
  detailViewTooltip,
  productView,
}: FlyoutLandingPageSectionProps & FormLockedType) => {
  const { classes } = useStyles()
  const [indexModal, setIndexModal] = useState(0)
  const [open, setOpen] = useState(false)

  const handleRefLinkClick = (index: number) => {
    setIndexModal(index)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const noOps = () => void 0

  return (
    <div className={classes.container} data-testid={'landing-page'}>
      <>
        <FlyOutProductBranding
          isFormLocked={false}
          defaultNow={defaultNow}
          detailView={detailView}
          detailViewTooltip={detailViewTooltip}
          handleRefLinkClick={handleRefLinkClick}
          productView={productView}
        />
        <FlyOutProductLandingPageConfiguration
          isFormLocked={false}
          detailView={detailView}
          detailViewTooltip={detailViewTooltip}
          handleRefLinkClick={handleRefLinkClick}
        />
        <FlyOutProductFormFields
          isFormLocked={false}
          detailView={detailView}
          detailViewTooltip={detailViewTooltip}
          handleRefLinkClick={handleRefLinkClick}
        />
        <FlyOutProductRedirectionSettingsMicrosoft
          isFormLocked={false}
          detailView={detailView}
          detailViewTooltip={detailViewTooltip}
          handleRefLinkClick={handleRefLinkClick}
        />
        {!productView && (
          <FlyOutProductAdhere
            sectionName={FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS}
          />
        )}
      </>

      <ModalConfirmV2
        title={`${landingPageImages[indexModal].heading}`}
        description={''}
        icon={
          <FontAwesomeIcon
            icon={faAws}
            style={{ height: '16px', width: '16px' }}
          />
        }
        content={
          <Carousel
            showHeading={false}
            carouselData={landingPageImages}
            handleImageClick={noOps}
            setCurrentIndex={setIndexModal}
            currentIndex={indexModal}
          />
        }
        open={open}
        titleAcceptButton={''}
        titleCancelButton={''}
        onDecline={handleClose}
        variant={ModalSizeVariants.large}
        hideAcceptButton={true}
        hideCancelButton={true}
        onAccept={noOps}
      />
    </div>
  )
}
